import { React, useState } from "react";
import styles from "./searchPage.module.css";
import LanguagePalsComp from "../../../components/languagePals/LanguagePalsComp";
import LearningZonesComp from "../../../components/learningZonesComp/LearningZonesComp";
import { GiThreeFriends } from "react-icons/gi";
import SearchPeople from "../../../components/searchPeople/SearchPeople";
import SearchPosts from "../../../components/searchPosts/SearchPosts";

const SearchPage = () => {
  /* The Search Page allows the user to search for other users, and for posts. Searching for other users can be done based on the type of cooperation they are seeking: language exchange, or learning the same language together (or both). The user should select the relevant languages, to try and find a match. Alternatively, the user can search for another user based on a free search query, which is matched against usernames, first names, and last names. Search results are linked to profile pages of the retrieved users. Searching for posts is done using keywords, which are looked up against posts textual contents. */

  const [activeTab, setActiveTab] = useState("people");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className={styles.main}>
      {/* main layout  */}
      <section className={styles.mainLayout}>
        {/* left section  */}
        <div className={styles.left}>
          <LearningZonesComp />
        </div>
        {/* middle section  */}
        <div className={styles.middle}>
          <section className={styles.search}>
            <h1>
              Search - Make Connections{" "}
              <span className={styles.headerIcon}>
                <GiThreeFriends />
              </span>
            </h1>
            <div className={styles.searchArea}>
              <div className={styles.searchTabs}>
                <button
                  onClick={() => handleTabClick("people")}
                  className={`${styles.tabButton} ${
                    activeTab === "people" ? styles.active : ""
                  }`}
                >
                  People
                </button>
                <button
                  onClick={() => handleTabClick("posts")}
                  className={`${styles.tabButton} ${
                    activeTab === "posts" ? styles.active : ""
                  }`}
                >
                  Posts
                </button>
              </div>
              <div className={styles.content}>
                {activeTab === "people" && <SearchPeople />}
                {activeTab === "posts" && <SearchPosts />}
              </div>
            </div>
          </section>
        </div>
        {/* right section  */}
        <div className={styles.right}>
          <LanguagePalsComp isOwn={true} />
        </div>
      </section>
    </div>
  );
};

export default SearchPage;
